import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'
import { MainColor } from '../../../pure-js/libs/Colors'
import { Images } from '../../../pure-js/libs/Images'
import RoutePath from '../../../pure-js/libs/RoutePath'
import config from '../Config'
import { BorderRadixes } from '../enums/BorderRadixes'
import { reallyBigSpacing } from '../enums/Spacings'
import useAppStateSession from '../hooks/useAppStateSession'
import { GameParams } from '../libs/GameHelper'
import { DASHBOARD_CALL_PANEL_WIDTH } from '../libs/HardCodedSizes'
import { MenuItem } from '../libs/MenuHelper'
import { AppBar } from './AppBar'
import Box from './Box'
import { DashboardCall } from './DashboardCall'
import FigmaImageContainer from './FigmaImageContainer'
import { PageContainer } from './PageContainer'
import { PlayGameUnity } from './PlayGameUnity'
import { PlayGameUnityExperimental } from './PlayGameUnityExperimental'

export function PlayGame({ gameParams }: { gameParams?: Partial<GameParams> }) {
  const { state } = useAppStateSession()
  const shouldShowCall = state.shouldShowCall && config.enableCall
  const Component = config.enableCall ? PlayGameUnityExperimental : PlayGameUnity

  return (
    <PageContainer fullWidth fullPadding fullHeight>
      <AppBar menuItem={MenuItem.playgame} />
      <Box fullWidth top>
        {!config.enableCall && <Component gameParams={gameParams} />}
        {!!shouldShowCall && <Component gameParams={gameParams} />}
        {!shouldShowCall && <PlayGameDashboardCall />}
      </Box>
    </PageContainer>
  )
}

const PlayGameDashboardCall = () => {
  const navigate = useNavigate()
  return (
    <Box fullWidth fullHeight align="center" justify="center">
      <Box fullWidth fullPadding fullHeight>
        <Box fullWidth>
          <Box onClick={() => navigate(RoutePath.GAME_CENTER)} pointer>
            <FigmaImageContainer imageKey={Images.backIcon} />
          </Box>
        </Box>
        <Box align="center" fullWidth fullHeight top spacing={reallyBigSpacing}>
          <Box width={`${DASHBOARD_CALL_PANEL_WIDTH}px`}>
            <Container fullPadding>
              <DashboardCall />
            </Container>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const Container = styled(Box)`
  border-radius: ${BorderRadixes.big};
  background-color: ${MainColor};
`
